import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SectionLabel from "@/components/SectionLabel";
import usePageMeta from "@/hooks/usePageMeta";

const partners = [
  {
    key: "evc-vigor",
    naam: "EVC Centrum VIGOR",
    rol: "EVC-trajecten & startkwalificaties",
    intro: "Geaccrediteerde partij die de competenties van deelnemers formeel beoordeelt en erkent volgens de landelijke standaard.",
    link: "/partners/evc-vigor",
  },
  {
    key: "welzijn",
    naam: "Lokale welzijnspartners",
    rol: "Wijknetwerk & buddy's",
    intro: "Per pilotregio werken we samen met de lokale welzijnsorganisatie voor instroom, buddy-koppeling en coaching in de wijk.",
  },
  {
    key: "werkgevers",
    naam: "Maatschappelijk betrokken werkgevers",
    rol: "Duurzame uitstroom",
    intro: "Netwerk van werkgevers die deelnemers overnemen, gecombineerd met onze werkgevers-training voor duurzame plaatsing.",
    link: "/trainingen/werkgevers",
  },
  {
    key: "outsideten",
    naam: "OutsideTen",
    rol: "Concept & moederorganisatie",
    intro: "LevelLeven is een concept van OutsideTen, verantwoordelijk voor doorontwikkeling van het model en het trainingsinstituut.",
  },
];

export default function Partners() {
  usePageMeta({
    title: "Partners, LevelLeven",
    description: "Onze samenwerkingspartners rondom de programma's en trainingen.",
  });
  return (
    <div>
      <section className="py-16 sm:py-24">
        <div className="max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-16">
          <div className="max-w-3xl reveal">
            <SectionLabel>Partners</SectionLabel>
            <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-[#1D2A22] font-light">
              LevelLeven werkt{" "}
              <span className="italic text-[#E06B3F]">nooit alleen</span>.
            </h1>
            <p className="mt-8 text-lg text-[#4A5D4E] leading-relaxed font-light">
              Duurzame verandering vraagt om een netwerk. Deze partners maken
              samen met ons de programma's en trainingen mogelijk.
            </p>
          </div>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-[1200px] mx-auto px-6 sm:px-10 lg:px-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {partners.map((p) => (
              <article key={p.key} data-testid={`partner-card-${p.key}`} className="reveal bg-[#FAF7F1] rounded-3xl border border-[#E5E1D8] p-8 hover:border-[#E06B3F] transition-colors">
                <p className="text-xs uppercase tracking-[0.25em] text-[#E06B3F] mb-3">{p.rol}</p>
                <h2 className="font-heading text-3xl text-[#1D2A22] leading-tight">{p.naam}</h2>
                <p className="mt-4 text-[#4A5D4E] leading-relaxed font-light">{p.intro}</p>
                {p.link && (
                  <Link to={p.link} className="mt-6 inline-flex items-center gap-2 text-sm text-[#E06B3F] hover:text-[#1D2A22] link-underline">
                    Meer informatie <ArrowUpRight size={14} />
                  </Link>
                )}
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
